<template>
  <div>
  <section>
    <div class="left">
      <h2 v-translate>Výběr operátora</h2>
    </div>
    <div class="right">
      <div class="field_left">
    <select-box
        id="operator_related_locality"
        :value="entity.id_operator"
        v-model="selectedOperatorId"
        :options="operatorOptions"
        :disabled="disableChangeOperator"
        @input="onOperatorChange"
    >
      <translate class="translate">Operátor</translate>
    </select-box>
      </div>
    </div>
  </section>
  <section>
  <SortableTable
    :is-editable="isEditable"
    :all-options="availibleLocalities"
    v-model="loadbalanceLocalities"
    :columns="sortingTableColumns"
    :title="$gettext('Zástupné lokality')"
    name="failover_localities"
    @input="onChange"
  />
  </section>
      <section>
  <SortableTable
      :is-editable="isEditable"
      :all-options="availibleLocalities"
      v-model="failoverLocalities"
      :columns="sortingTableColumns"
      :title="$gettext('Záložní lokality')"
      name="loadbalanced_localities"
      @input="onChange"
  />
      </section>
  </div>
</template>

<script>
import SortableTable from "../../../common/SortableTable.vue"
import message from "../../../mixins/message";

export default {
  name: "RelatedLocalities",
  mixins: [message],
  components: {SortableTable},
  props: {
    isEditable: Boolean,
    entity: Object,
    operatorOptions: Array,
  },
  created(LocalityService){
    this.localityService = LocalityService
    this.onOperatorChange();
  },
  data(){
    return {
      failoverLocalities: [],
      loadbalanceLocalities: [],
      availibleLocalities: [],
      selectedOperatorId: this.entity.id_operator,
    }
  },
  computed: {
    sortingTableColumns(){
      return [
        {text: this.$gettext('Název'), value: 'name'},
        {text: this.$gettext('Operátor'), value: 'operator_name'},
      ]
    },
    disableChangeOperator(){
      return !this.$_updateActionAllowedAllOrOwnAndGlobal || !this.isEditable || !!this.entity.id_operator
    }
  },
  methods: {
    onOperatorChange(){
      this.localityService.getRelatedLocalities(this.entity.id, {id_operator: this.selectedOperatorId})
          .then((data) => {
            this.failoverLocalities = data.failover_localities;
            this.loadbalanceLocalities = data.loadbalance_localities;
            this.availibleLocalities = data.available_localities;
          });
    },
    onChange(){
      this.setLoadingMessage();
      this.localityService.setRelatedLocalities(this.entity.id, {
        id_operator: this.selectedOperatorId,
        failover_localities: this.failoverLocalities,
        loadbalance_localities: this.loadbalanceLocalities
      })
          .then(() => {
            this.onOperatorChange();
            this.setSuccessMessage();
          });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/localities/locality/RelatedLocalities.vue